import React from 'react';
import { translate } from '@utils/i18n';
import { namespace } from './constants';
import LocationDisplay from '../../FormLibrary/LocationDisplay';
const getColumnsDefinition = ({ onClickItem, territories = [] }) => [
    {
        label: translate('headers.display_name', { namespace }),
        dataKey: 'displayName',
        renderer: ({ item }) => {
            var _a, _b;
            return (React.createElement("div", null, ((_a = item.template) === null || _a === void 0 ? void 0 : _a.pdfFileUrl) ? (React.createElement("a", { href: (_b = item.template) === null || _b === void 0 ? void 0 : _b.pdfFileUrl, target: "_blank", rel: "noopener noreferrer" }, item.displayName)) : (React.createElement("span", null, item.displayName))));
        }
    },
    {
        label: translate('headers.location', { namespace }),
        dataKey: 'location',
        renderer: ({ item }) => {
            var _a, _b, _c, _d;
            const territoryNames = ((_a = item.territoryIds) === null || _a === void 0 ? void 0 : _a.length)
                ? territories.filter((t) => item.territoryIds.includes(t.value)).map((t) => t.label)
                : [];
            return (React.createElement("div", null,
                React.createElement(LocationDisplay, { city: (_b = item.template) === null || _b === void 0 ? void 0 : _b.city, state: (_c = item.template) === null || _c === void 0 ? void 0 : _c.state, country: (_d = item.template) === null || _d === void 0 ? void 0 : _d.country }),
                territoryNames.length > 0 && (React.createElement("div", { className: "location-badges-container", style: { marginTop: '4px' } }, territoryNames.map((name) => (React.createElement("span", { key: name, className: "location-territory-badge" }, name)))))));
        }
    },
    {
        label: translate('headers.active', { namespace }),
        dataKey: 'active',
        renderer: ({ item }) => React.createElement("span", null, translate(item.active ? 'yes' : 'no', { namespace: 'generic' }))
    },
    {
        label: translate('headers.frequency', { namespace }),
        dataKey: 'frequencyString'
    },
    {
        label: '',
        dataKey: 'id',
        renderer: ({ item }) => (React.createElement("button", { type: "button", title: "Edit Details", className: "qmb-control--icon", onClick: () => onClickItem(item) },
            React.createElement("i", { className: "fa-light fa-pencil", "aria-hidden": "true" })))
    }
];
export default getColumnsDefinition;
